var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  A Use Case library for interacting with the Pubsub Entity.
*/
var DEFAULT_COORDINATION_ROOM = 'psf-ipfs-coordination-002';

var PubsubUseCase = /*#__PURE__*/function () {
  "use strict";

  function PubsubUseCase() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PubsubUseCase);

    // Dependency Injection.
    this.adapters = localConfig.adapters;

    if (!this.adapters) {
      throw new Error('Must inject instance of adapters when instantiating Pubsub Use Cases library.');
    }

    this.controllers = localConfig.controllers;

    if (!this.controllers) {
      throw new Error('Must inject instance of controllers when instantiating Pubsub Use Cases library.');
    }

    this.thisNodeUseCases = localConfig.thisNodeUseCases;

    if (!this.thisNodeUseCases) {
      throw new Error('thisNode use cases required when instantiating Pubsub Use Cases library.');
    }
  } // Connect to the default pubsub rooms.


  _createClass(PubsubUseCase, [{
    key: "initializePubsub",
    value: function () {
      var _initializePubsub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(thisNode) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.adapters.pubsub.subscribeToPubsubChannel(DEFAULT_COORDINATION_ROOM, // this.adapters.peers.addPeer
                this.thisNodeUseCases.addSubnetPeer, thisNode);

              case 3:
                _context.next = 9;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                console.error('Error in pubsub-use-cases.js/initializePubsub()');
                throw _context.t0;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function initializePubsub(_x) {
        return _initializePubsub.apply(this, arguments);
      }

      return initializePubsub;
    }()
  }]);

  return PubsubUseCase;
}();

module.exports = PubsubUseCase;